import { render, staticRenderFns } from "./approvalDateRange.vue?vue&type=template&id=23db5c9e&scoped=true&"
import script from "./approvalDateRange.vue?vue&type=script&lang=js&"
export * from "./approvalDateRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db5c9e",
  null
  
)

export default component.exports